export function normalizeSfdcStage(raw: string): string {
  const s = raw.toLowerCase().trim();
  if (s.includes('tech validation') || s.includes('technical validation')) return 'Tech Validation';
  if (s.includes('biz validation') || s.includes('business validation')) return 'Biz Validation';
  // Closed Lost must be checked BEFORE Committed: 'closed won' maps to Committed, but 'closed lost'
  // is a terminal failure that carries its own color and must not fold into Others. The match is
  // the FULL 'closed lost' phrase, not a bare 'lost' substring — a future upstream stage like
  // 'Prospect - lost deal' or 'Lost Then Reopened' is NOT Closed Lost and must not paint red.
  if (s.includes('closed lost')) return 'Closed Lost';
  if (s.includes('committed') || s.includes('closed won')) return 'Committed';
  if (s.includes('launched')) return 'Launched';
  if (s.includes('qualified')) return 'Qualified';
  if (s.includes('prospect')) return 'Prospect';
  return 'Others';
}

/**
 * Stage pill fill colors from the Figma color table (node 4461:50823), as directed in
 * DAT-9259 2026-10-27 (the 2026-10-27 description supersedes earlier sampling comments).
 * All seven are read with WHITE text at the call site.
 */
export const SFDC_STAGE_COLOR: Record<string, string> = {
  'Prospect': '#b0901c',
  'Qualified': '#2ca494',
  'Tech Validation': '#ec702c',
  'Biz Validation': '#3084c0',
  'Committed': '#6840b0',
  'Launched': '#689800',
  'Closed Lost': '#d80000',
  'Others': '#8094a4',
};

export const SFDC_STAGE_ORDER = [
  'Prospect', 'Qualified', 'Tech Validation', 'Biz Validation',
  'Committed', 'Launched', 'Closed Lost', 'Others',
];
